module.exports = __webpack_public_path__ + "img/truck-plate.f6600efa.svg";